import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) { return (_pushScopeId("data-v-a90b542c"), n = n(), _popScopeId(), n); };
var _hoisted_1 = {
    key: 0,
    class: "text-xs text-center uppercase text-gray-300 font-medium px-2 pt-2.5 pb-1"
};
var _hoisted_2 = {
    key: 1,
    style: { maxHeight: 'var(--e-menu-max-h)' },
    class: "e-menu__content"
};
var _hoisted_3 = {
    key: 0,
    class: "text-xs text-center uppercase text-gray-300 font-medium px-2 pt-2.5 pb-1"
};
import { computed, inject, onMounted, onUnmounted, provide } from 'vue';
import { providePopperKey } from '@common/ui/EPopper/providePopperKey';
import EScrollbar from '@common/ui/EScrollbar.vue';
import { generateUuid } from '@common/utils/Helpers/Helpers';
import { provideMenuKey } from '@common/ui/EMenu/provideMenuKey';
import hotkeys from 'hotkeys-js';
export default /*#__PURE__*/ _defineComponent({
    __name: 'EMenu',
    props: {
        label: {},
        theme: { default: 'light' },
        maxHeight: {},
        scrollOffset: { default: 0 },
        autoheight: { type: Boolean, default: true },
        withScrollbar: { type: Boolean, default: true },
        suppressScrollX: { type: Boolean, default: false }
    },
    setup: function (__props) {
        var props = __props;
        var hotkeyScope = 'e-dropdown-' + generateUuid();
        var lastScope;
        var popperData = inject(providePopperKey, null);
        onMounted(function () {
            lastScope = hotkeys.getScope();
            hotkeys.setScope(hotkeyScope);
        });
        onUnmounted(function () {
            hotkeys.setScope(lastScope);
            hotkeys.deleteScope(hotkeyScope);
        });
        var maxHeightStyle = computed(function () {
            if (!props.autoheight || (!props.maxHeight && !popperData))
                return '';
            return ((props.maxHeight || (popperData === null || popperData === void 0 ? void 0 : popperData.maxHeight.value)) - props.scrollOffset) + 'px';
        });
        provide(provideMenuKey, {
            hotkeyScope: hotkeyScope,
        });
        return function (_ctx, _cache) {
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass([[
                        "e-menu--".concat(_ctx.theme),
                    ], "e-menu"]),
                style: _normalizeStyle({ '--e-menu-max-h': maxHeightStyle.value })
            }, [
                (_ctx.withScrollbar)
                    ? (_openBlock(), _createBlock(EScrollbar, {
                        key: 0,
                        options: {
                            wheelPropagation: false,
                            suppressScrollX: _ctx.suppressScrollX
                        },
                        style: { maxHeight: 'var(--e-menu-max-h)' }
                    }, {
                        default: _withCtx(function () { return [
                            (_ctx.label)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_1, _toDisplayString(_ctx.label), 1))
                                : _createCommentVNode("", true),
                            _renderSlot(_ctx.$slots, "default")
                        ]; }),
                        _: 3
                    }, 8, ["options"]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_2, [
                        (_ctx.label)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(_ctx.label), 1))
                            : _createCommentVNode("", true),
                        _renderSlot(_ctx.$slots, "default")
                    ]))
            ], 6));
        };
    }
});
